var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventHostFun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "37px",
    viewBox: "0 0 42 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EventHostFun") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.4709201%",
    y1: "0%",
    x2: "61.8674045%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5200",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8200",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom-Event-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1041.000000, -218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(222.000000, 213.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M839.999999,42 C835.610747,42 819.0008,31.4053023 819.0008,17.0963091 C818.925369,10.5030805 824.19412,5.0923766 830.779755,5 C834.39541,5.0151055 837.800205,6.70585552 839.999999,9.57858182 C842.199876,6.70572882 845.604858,5.01496277 849.220664,5 C855.806154,5.09256012 861.074678,10.5032237 860.999199,17.0963091 C860.999199,31.4053023 844.389588,42 839.999999,42 Z M849.220664,8.36363636 C843.775572,8.36363636 841.928398,13.4090909 839.999999,13.4090909 C838.071601,13.4090909 836.224427,8.36363636 830.779419,8.36363636 C826.048813,8.45445119 822.283506,12.360162 822.360672,17.0963091 C822.360672,29.794625 837.802139,38.6101273 839.999999,38.6363636 C842.197944,38.6101273 857.639327,29.794625 857.639327,17.0963091 C857.716448,12.3603556 853.951408,8.45476397 849.221,8.36372045 L849.220664,8.36363636 Z",
    id: "EventHostFun"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventHostFun);
export default __webpack_public_path__ + "static/media/EventHostFun.8edc6219562f4a9a0f7ec6212e691611.svg";
export { ForwardRef as ReactComponent };